import { get, post, getHost } from '@kk-activity-factory/utils';
import { type GetRankByIdResponse } from './types/rankListType';

const HOST = getHost();

/**
 * https://yapi.quickcan.com/project/163/interface/api/113638
 * 获取作品排行榜数据
 * @param id 排行榜id
 * @param rankDisplayType 周期类型，1当前周期，2 上周期 默认当前周期
 */
export function getRankById(
    id: number,
    rankDisplayType: number,
    displayModuleConfigId: string,
    pageIndex?: number,
    pageSize?: number
): Promise<GetRankByIdResponse> {
    return get({
        url: `${HOST}/gamecard/v2/topicRank/get_rank_by_id`,
        data: {
            id,
            rankDisplayType,
            displayModuleConfigId,
            pageIndex,
            pageSize,
        },
    });
}

/**
 * https://yapi.quickcan.com/project/163/interface/api/113656
 * 搜索作品
 * @param q 搜索关键词
 * @param displayModuleConfigId 模块id
 */
export function searchTopic(
    q: string,
    displayModuleConfigId: string
): Promise<GetRankByIdResponse> {
    return get({
        url: `${HOST}/gamecard/v2/topicRank/searchTopic`,
        data: {
            q,
            displayModuleConfigId,
        },
    });
}

// 关注漫画
export function followComics(topicId: number) {
    return post({
        url: `${HOST}/v2/h5/topic/${topicId}/fav`,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

// 取关漫画
export function unFollowComics(topicId: number) {
    return request({
        type: 'DELETE',
        url: `${HOST}/v2/h5/topic/${topicId}/fav`,
    });
}

/**
 * 给作品投掷金币
 * @param topicId 专题id
 * @param displayModuleConfigId 模块配置id
 */
export function peltCoin(
    topicId: number,
    displayModuleConfigId: string
): Promise<{
    code: number;
    message: string;
}> {
    return post({
        url: `${HOST}/gamecard/v2/topicRank/peltCoin`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: {
            topicId,
            displayModuleConfigId,
        },
    });
}

export function userBaseInfo(userId: string) {
    return get({
        headers: {
            'Content-Type': 'application/json',
        },
        url: `${HOST}/gamecard/v2/activityModule/userBaseInfo`,
        data: {
            userId,
        },
    });
}

export function reportUserEvent(data: {
    topicId?: number;
    rankId?: number;
    rankEventType?: number;
    content?: string;
    eventType?: number;
    displayModuleConfigId?: string;
}): Promise<{
    code: number;
    message: string;
}> {
    return post({
        url: `${HOST}/gamecard/v2/activity/common/userevent/report`,
        headers: {
            'Content-Type': 'application/json',
        },
        data,
    });
}
